var _rect, _g, _rect2, _rect3, _rect4, _rect5, _g2, _g3, _g4, _g5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdfHeader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 966,
    height: 136,
    viewBox: "0 0 966 136",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6181_131715)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 966,
    height: 136,
    rx: 20,
    fill: "url(#paint0_linear_6181_131715)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.53
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2235.75,
    height: 1008.08,
    transform: "matrix(1 0 0 -1 -258.5 493.938)",
    fill: "url(#paint1_linear_6181_131715)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.44
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.72
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 2235.75,
    height: 1008.08,
    transform: "matrix(1 0 0 -1 -257.5 501.938)",
    fill: "url(#paint2_linear_6181_131715)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "plus-lighter"
    },
    opacity: 0.86
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 616.811,
    height: 1934.09,
    transform: "matrix(0.915556 0.402191 0.402191 -0.915556 873.727 1031.25)",
    fill: "url(#paint3_linear_6181_131715)"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 635.342,
    height: 1481.89,
    transform: "matrix(0.915556 0.402191 0.402191 -0.915556 173.664 1045.2)",
    fill: "url(#paint4_linear_6181_131715)",
    fillOpacity: 0.85
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "lighten"
    }
  }, _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 779.062,
    y: -1105,
    width: 616.811,
    height: 1347.46,
    transform: "rotate(23.7152 779.062 -1105)",
    fill: "url(#paint5_linear_6181_131715)",
    fillOpacity: 0.37
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.37
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.57533,
    height: 3.67195,
    rx: 1.78767,
    transform: "matrix(-1 0 0 1 310.274 34.1562)",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.57533,
    height: 3.67195,
    rx: 1.78767,
    transform: "matrix(-1 0 0 1 258.43 56.1875)",
    fill: "#FBFBFB",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.57533,
    height: 3.67195,
    rx: 1.78767,
    transform: "matrix(-1 0 0 1 599.867 59.8594)",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.57533,
    height: 3.67195,
    rx: 1.78767,
    transform: "matrix(-1 0 0 1 43.9065 58.0234)",
    fill: "white",
    fillOpacity: 0.2
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.33
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_6181_131715)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.56201,
    cy: 1.56006,
    rx: 1.56201,
    ry: 1.56006,
    transform: "matrix(0.00309406 -0.999995 -0.999995 -0.00310509 894.719 128.812)",
    fill: "#8EF8FF",
    fillOpacity: 0.95,
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_6181_131715)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.56201,
    cy: 1.56006,
    rx: 1.56201,
    ry: 1.56006,
    transform: "matrix(0.00309406 -0.999995 -0.999995 -0.00310509 838.703 84.875)",
    fill: "#8EF8FF",
    fillOpacity: 0.95,
    shapeRendering: "crispEdges"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.53
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1708,
    height: 1205,
    transform: "matrix(1 0 0 -1 -158.5 275)",
    fill: "url(#paint6_linear_6181_131715)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.47
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2.50749,
    height: 2.57526,
    rx: 1.25375,
    transform: "matrix(-1 0 0 1 905.913 58.8281)",
    fill: "white",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.50749,
    height: 2.57526,
    rx: 1.25375,
    transform: "matrix(-1 0 0 1 225.132 120.633)",
    fill: "white",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.50749,
    height: 2.57526,
    rx: 1.25375,
    transform: "matrix(-1 0 0 1 210.085 43.375)",
    fill: "#FBFBFB",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.50749,
    height: 2.57526,
    rx: 1.25375,
    transform: "matrix(-1 0 0 1 700.304 106.469)",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.50749,
    height: 2.57526,
    rx: 1.25375,
    transform: "matrix(-1 0 0 1 692.78 75.5625)",
    fill: "white",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.50749,
    height: 2.57526,
    rx: 1.25375,
    transform: "matrix(-1 0 0 1 957.319 7.32812)",
    fill: "white",
    fillOpacity: 0.3
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_6181_131715",
    x: 888.657,
    y: 122.737,
    width: 9.0127,
    height: 9.01758,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.47315
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.815686 0 0 0 0 0.937255 0 0 0 0 0.901961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6181_131715"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6181_131715",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_6181_131715",
    x: 832.642,
    y: 78.7998,
    width: 9.0127,
    height: 9.01758,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.47315
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.815686 0 0 0 0 0.937255 0 0 0 0 0.901961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6181_131715"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6181_131715",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6181_131715",
    x1: 303.147,
    y1: 10.88,
    x2: 481.516,
    y2: 500.692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.101472,
    stopColor: "#0A1111"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460623,
    stopColor: "#0F1818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E2828"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6181_131715",
    x1: 1117.87,
    y1: -146.545,
    x2: 1117.87,
    y2: 1008.08,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#549E9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.592001,
    stopColor: "#151518",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6181_131715",
    x1: 994.601,
    y1: -249.941,
    x2: 1089.48,
    y2: 1730.42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0320432,
    stopColor: "#83CAB5",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.148153,
    stopColor: "#26655F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.485707,
    stopColor: "#151518",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.740325,
    stopColor: "#1F504B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6181_131715",
    x1: 291.214,
    y1: -338.612,
    x2: 281.65,
    y2: 1933.07,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7BDCD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151518",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_6181_131715",
    x1: 93.8275,
    y1: 262.485,
    x2: 361.493,
    y2: 1868.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0568639,
    stopColor: "#6EC5BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.777608,
    stopColor: "#151518",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_6181_131715",
    x1: 1060.11,
    y1: -1084.19,
    x2: 959.849,
    y2: 289.166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#94E6DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151518",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_6181_131715",
    x1: 854,
    y1: -175.171,
    x2: 854,
    y2: 1247.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#549E9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616512,
    stopColor: "#17181A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6181_131715"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 966,
    height: 136,
    rx: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfHeader);
export default __webpack_public_path__ + "static/media/pdf-header.1e648dbc5ce86ec4b577b03f027c3ded.svg";
export { ForwardRef as ReactComponent };